export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundColor: theme.palette.purple.main,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    height: '100%',
    width: '70%',
    top: 0,
    left: 0,
    background: `no-repeat url(${theme.url('/blocks/b27-bg.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left',
  },
  greyRectangle: {
    position: 'absolute',
    zIndex: 2,
    bottom: 0,
    right: 0,
    height: '40%',
    width: '85%',
    background: theme.palette.grey.light,
  },
  purpleRectangle: {
    position: 'absolute',
    zIndex: 2,
    top: '60%',
    right: 0,
    height: '20%',
    width: '85%',
    background: theme.palette.purple.main,
  },
  purpleCurve: {
    position: 'absolute',
    zIndex: 2,
    top: '60%',
    right: 0,
    height: '40%',
    width: '100%',
    background: `no-repeat url(${theme.url('/blocks/b27-purple-curve.svg')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left bottom',
  },
  blur: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    background: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(12px)',
    height: '60%',
    width: '50%',
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    top: '8%',
    left: '10%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  content: {
    position: 'relative',
    zIndex: 5,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      height: 'initial',
      right: 'initial',
      paddingBottom: theme.spacing(2),
    },
  },
  desc: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    right: 0,
    height: '60%',
    width: '30%',
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      padding: theme.spacing(4),
      margin: theme.spacing(2),
      marginBottom: theme.spacing(6),
    },
  },
  text: {
    position: 'absolute',
    // minWidth: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      minWidth: 'initial',
      top: 0,
      left: 0,
      transform: 'initial',
    },
  },
  history: {
    position: 'absolute',
    zIndex: 2,
    top: '70%',
    right: '2%',
    width: '82%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      right: 'initial',
      width: 'initial',
      marginBottom: theme.spacing(4),
    },
  },
  step: {
    position: 'relative',
    display: 'inline-block',
    paddingTop: '3%',
    textAlign: 'center',
    verticalAlign: 'top',
    lineHeight: 0.5,
    width: '20%',
    borderTop: `4px solid ${theme.palette.secondary.main}`,
    cursor: 'pointer',
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      marginRight: theme.spacing(1),
      height: 30,
      width: 30,
      borderRadius: 30,
      top: 0,
      left: '50%',
      transform: 'translate(calc(-50% - 2px),calc(-50% - 2px))',
      border: `solid 4px ${theme.palette.white.main}`,
      backgroundColor: theme.palette.purple.main,
    },
    '&:first-child:before': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      marginRight: theme.spacing(1),
      height: 15,
      width: 15,
      borderRadius: 30,
      top: 0,
      left: 0,
      transform: 'translate(calc(-50% - 2px),calc(-50% - 2px))',
      border: `solid 4px ${theme.palette.white.main}`,
      backgroundColor: theme.palette.white.main,
      cursor: 'unset',
    },
    '&:last-child:before': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      marginRight: theme.spacing(1),
      height: 20,
      width: 4,
      top: 0,
      right: 0,
      transform: 'translateY(-4px) rotate(45deg)',
      backgroundColor: theme.palette.white.main,
      cursor: 'unset',
    },
    '&:last-child > *:before': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      marginRight: theme.spacing(1),
      height: 20,
      width: 4,
      top: 0,
      right: 0,
      transform: 'translateY(-100%) rotate(-45deg)',
      backgroundColor: theme.palette.white.main,
      cursor: 'unset',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '80%',
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
      margin: 'auto',
      borderTop: 'none',
      borderLeft: `4px solid ${theme.palette.secondary.main}`,
      '&:after': {
        marginRight: theme.spacing(1),
        height: 30,
        width: 30,
        borderRadius: 30,
        top: '50%',
        left: 0,
      },
      '&:first-child:before': {
        marginRight: theme.spacing(1),
        height: 15,
        width: 15,
        borderRadius: 30,
        top: 0,
        left: 0,
        cursor: 'unset',
      },
      '&:last-child:before': {
        top: '100%',
        left: 0,
        transform: 'translateX(4px) translateY(-100%) rotate(45deg)',
        backgroundColor: theme.palette.white.main,
        cursor: 'unset',
      },
      '&:last-child > *:before': {
        top: '100%',
        left: 0,
        transform: 'translateX(-12px) translateY(-100%) rotate(-45deg)',
        backgroundColor: theme.palette.white.main,
        cursor: 'unset',
      },
    },
  },
});
